export class CableStringToInt {
    one = 1;
    five = 5;
    ten = 10;
    fifteen = 15;
    twenty = 20;
    thirty = 30;
    fifty = 50;
}
